export const SERVICE_CATEGORY_GET_REQUEST = 'SERVICE_CATEGORY_GET_REQUEST'
export const SERVICE_CATEGORY_GET_SUCCESS = 'SERVICE_CATEGORY_GET_SUCCESS'
export const SERVICE_CATEGORY_GET_ERROR = 'SERVICE_CATEGORY_GET_ERROR'

export const SERVICE_PACKAGE_GET_REQUEST = 'SERVICE_PACKAGE_GET_REQUEST'
export const SERVICE_PACKAGE_GET_SUCCESS = 'SERVICE_PACKAGE_GET_SUCCESS'
export const SERVICE_PACKAGE_GET_ERROR = 'SERVICE_PACKAGE_GET_ERROR'